var QUEO = window.QUEO || {};

QUEO.select = (function ($, w, d) {
    var $w = $(w),
        $d = $(d);

    function init() {

        $('.js-form-select-queo:not(.js-initialized)').addClass('js-initialized').each(function(i) {

            var $component = $(this),
                $trigger = $component.find('button'),
                $select = $component.find('select'),
                select = $select.get(0),
                $value = $component.find('.js-form-select-value'),
                isMultiple = $select.attr('multiple'),
                toggleType = isMultiple ? 'checkbox' : 'radio',
                $selectContainer = $component.find('.js-form-select-queo-container'),
                selectContainer = $selectContainer.get(0),
                $selectList = createSelectList(),
                selectList = $selectList.get(0),
                $toggles = $component.find('input[type="' + toggleType + '"]'),
                _isReactEvent = false,
                observeSelect = new MutationObserver(function(mutations) {

                    mutations.forEach(function(mutation) {

                        if (mutation.type === "attributes") {

                            $trigger.attr('disabled', mutation.target.disabled);

                        }

                    });

                    updateDropdownLabel();

                }),
                observeOption = new MutationObserver(function() {

                    var $option;

                    $select.find('option').each(function() {

                        $option = $(this);

                        $selectList.find('input[value="'+ $option.attr('value') + '"]').closest('.js-form-select-queo-option').toggleClass('is-hidden', $option.hasClass('is-hidden'));

                    });

                    updateDropdownLabel();

                });

            // watch for "disabled" attribute change on select element
            observeSelect.observe($select.get(0), {
                attributes: true,
                attributeFilter: ['disabled']
            });

            // watch for "is-hidden" via "class" attribute change on option element
            observeOption.observe($select.get(0), {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });

            // update change event (when triggered outside of component) of select to update label and triggers
            $select.on('change', function(e) {

                // ignore if it is an event meant for react
                if(_isReactEvent) {

                    e.preventDefault();

                    _isReactEvent = false;

                    return;

                }

                var values = $select.val(),
                    value,
                    $toggle,
                    isChecked;

                $toggles.each(function() {

                    $toggle = $(this);
                    value = $toggle.val();

                    isChecked = values && values.length ? (isMultiple ? value.indexOf(values) !== -1 : value === values) : false;

                    $toggle.prop('checked', isChecked);

                });

                updateDropdownLabel();

            });

            $toggles.on('change', updateDropdownLabel);
            if(!isMultiple) {

                $toggles.on('click', function() {

                    $trigger.trigger('click');

                });

            }
            updateDropdownLabel();

            // auto-submit (note: this event must be registered AFTER initial call to updateDropdownLabel)
            $select.filter('.js-auto-submit').on('change', function() {

                $(this).closest('form').submit();

            });

            // either use data-placeholder (via css :empty) or concatenate values (also silently update selected state of options)
            function updateDropdownLabel() {

                var value = [],
                    valueText = [],
                    _valueText,
                    currentValue = $select.val(),
                    $toggle,
                    isChecked,
                    nativeSelectValueSetter,
                    reactEvent;

                $toggles.each(function() {

                    $toggle = $(this);
                    isChecked = $toggle.is(':checked');

                    if(isChecked) {

                        value.push($toggle.val());

                        // concatenate values for dropdown label
                        _valueText = $toggle.next('label').text().trim();
                        if(_valueText.length) {

                            valueText.push(_valueText);

                        }

                    }

                });

                // update select (won't cause a change event)
                $select.val(value);

                // update button text
                $value.text(valueText.length ? valueText.join(', ') : '');

                // emit change event to react, see: https://hustle.bizongo.in/simulate-react-on-change-on-controlled-components-baa336920e04
                if(currentValue !== value) {

                    _isReactEvent = true;

                    nativeSelectValueSetter = Object.getOwnPropertyDescriptor(
                        window.HTMLSelectElement.prototype,
                        "value"
                    ).set;
                    nativeSelectValueSetter.call(select, value);

                    reactEvent = new Event("change", {bubbles: true});
                    select.dispatchEvent(reactEvent);

                }

            }

            $trigger.on('click', function(e) {

                if($trigger.is(':disabled')) {

                    e.preventDefault();
                    return;

                }

                bindHandler($trigger.toggleClass('is-open').is('.is-open'));

            });

            // bind or unbind handlers (also calculate alignment and init vars on bind)
            function bindHandler(bind) {

                if(bind) {

                    // bind events when open
                    $d.on('click', outsideHandler).on('keydown', keyHandler);
                    $w.on('scroll resize', alignment);
                    $selectList.on('wheel', scrollHandler);

                    // also calculate alignment
                    alignment();

                    fauxName(true);

                } else {

                    // unbind events when close
                    $d.off('click', outsideHandler).off('keydown', keyHandler);
                    $w.off('scroll resize', alignment);
                    $selectList.off('wheel', scrollHandler);

                    fauxName(false);

                }

            }

            // close on outside click/focus
            function outsideHandler(e) {

                if(e.target === selectContainer || $(e.target).closest('.js-form-select-queo-container').get(0) === selectContainer) {

                    return;

                }

                $trigger.removeClass('is-open');

                bindHandler(false);

            }

            // keyboard handler (TAB, ENTER, SPACE, ESC, KEY DOWN/UP)
            function keyHandler(e) {

                var key = e.originalEvent.keyCode,
                    prevent = true,
                    select = false,
                    $currentToggle = $toggles.filter(':focus');

                if($currentToggle.length === 0) {

                    $currentToggle = isMultiple ? $toggles.eq(0).filter(':focus') : $toggles.filter(':checked').eq(0);

                }

                switch(key) {

                    case 9 : // tab
                    case 13: // enter
                    case 32: // space

                        if(isMultiple) {

                            if(key !== 32) {

                                select = true;

                            }

                        } else {

                            $toggles.filter(':focus').prop('checked', true);
                            updateDropdownLabel();
                            select = true;

                        }

                        break;

                    case 27: // esc

                        select = true;

                        break;

                    case 38: // key up

                        if($currentToggle.parent().prev().length) {
                            $toggles.eq($currentToggle.parent().prevAll().length - 1).focus();
                        } else {
                            $toggles.eq(-1).focus();
                        }

                        break;

                    case 40: // key down

                        if($currentToggle.parent().next().length) {
                            $toggles.eq($currentToggle.parent().prevAll().length + 1).focus();
                        } else {
                            $toggles.eq(0).focus();
                        }

                        break;

                    default:

                        prevent = false;

                }

                if(prevent) {

                    e.preventDefault();

                }

                if(select && key !== 32) {

                    $trigger.trigger('click').trigger('focus');

                } else if(select) {

                    $trigger.focus();

                }

            }

            // prevents outside scrolling while scrolling inside box
            function scrollHandler(e) {

                var originalEvent = e.originalEvent,
                    boxHeight = $selectList.outerHeight(),
                    scrollHeight = selectList.scrollHeight + parseInt(getComputedStyle(selectList, 'border-top-width')) + parseInt(getComputedStyle(selectList, 'border-bottom-width')),
                    scrollTop = selectList.scrollTop,
                    deltaY;

                // nothing to scroll - skip
                if(boxHeight === scrollHeight) {

                    return;

                }

                // Note: please DON'T(!) change to "if else" as this breaks things (due to bad implementation in some browsers using some properties but not populating them)
                if('detail' in originalEvent) {

                    deltaY = originalEvent.detail * -1;

                }
                if('wheelDelta' in originalEvent) {

                    deltaY = originalEvent.wheelDelta;

                }
                if('wheelDeltaY' in originalEvent) {

                    deltaY = originalEvent.wheelDeltaY;

                }
                if('deltaY' in originalEvent) {

                    deltaY = originalEvent.deltaY * -1;

                }

                // prevent over-scrolling (meaning document will be scrolled instead of dropdown item list)
                // Note: if "reached bottom" && "scrolled down" OR "reached top" && "scrolled up"
                if(scrollTop === scrollHeight - boxHeight && deltaY < 0 || scrollTop === 0 && deltaY > 0) {

                    e.preventDefault();

                }

            }

            // calculate alignment (above or below)
            function alignment() {

                var vpTop = -$w.scrollTop() + $trigger.offset().top,
                    listHeight = $selectList.outerHeight(true),
                    spaceLeftAbove = vpTop - listHeight,
                    spaceLeftBelow = (w.innerHeight - vpTop) - ($trigger.outerHeight(true) + listHeight);

                // Note: prefer below even when there is too little space above and below
                $selectContainer.toggleClass('is-drop-up', spaceLeftBelow < 0 && spaceLeftAbove > spaceLeftBelow);

            }

            // toggle faux name on checkbox/radio (although it is only really needed for radio)
            function fauxName(isOpen) {

                $toggles.attr('name', isOpen ? 'fauxName' : null);

            }

            function createSelectList() {

                var $selectList = $('<ul class="js-form-select-queo-list" tabindex="-1"/>'),
                    $options = $select.find('option'),
                    index,
                    $option;

                // set first option to selected if none was selected (but only if placeholder is not present)
                if($options.filter('[selected]').length === 0 && !$value.data('placeholder')) {

                    $options.eq(0).attr('selected', true);

                }

                $options.each(function(j) {

                    index = 'QUEO_' + i + '_' + j + '_' + Date.now();

                    $option = $(this);

                    $selectList.append(
                        $('<li class="js-form-select-queo-option"/>').append([
                            $('<input/>').attr({
                                id: index,
                                value: $option.attr('value'),
                                disabled: $option.attr('disabled'),
                                checked: $option.attr('selected'),
                                type: toggleType,
                                ariaDescribedby: $select.attr('aria-describedby')
                            }),
                            $('<label/>').attr({
                                for: index
                            }).append($('<span class="focus-item"/>').text($option.text()))
                        ])
                    );

                });

                $trigger.after($selectList);

                return $selectList;

            }

            function getComputedStyle(el, prop) {

                var styles = w.getComputedStyle(el);

                return styles.getPropertyValue(prop);

            }

        });

    }

    $(init);

    return {
        init: init
    }
})(jQuery, window, document);
